import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import About from './views/About.vue'
import Support from './views/Support.vue'
import Pricing from './views/Pricing.vue'
import Terms from './views/Terms'
import Contact from './views/Contact'
import Clients from './views/Clients'
import Features from './views/Features'

import ApiReference from './views/developers/ApiReference'
import ApiStatus from './views/developers/ApiStatus'
import Documentation from './views/developers/Documentation'
import DevFAQ from './views/developers/FAQ'
import Sdk from './views/developers/Sdk'
import Developers from './views/developers/Developers'

import BusFAQ from './views/business/FAQ'
import BusRecPay from './views/business/ReceivePayments'
import BusSendIn from './views/business/SendInvoices'
import BusSol from './views/business/Solutions'
import BusPricing from './views/business/Pricing'
import Business from './views/business/Business'

import PerFAQ from './views/personal/FAQ'
import PerHowTo from './views/personal/HowTo'
import PerOnPay from './views/personal/OnlinePayment'
import PerReqPay from './views/personal/RequestPayment'
import PerSenPay from './views/personal/SendPayment'

import FOF from './views/404'

import Blog from './views/blog/Blog'
import BlogSingle from './views/blog/BlogSingle'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/support',
      name: 'support',
      component: Support
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Pricing
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/features',
      name: 'features',
      component: Features
    },
    {
      path: '/blog',
      component: Blog,
      children: [
        {
          path: 'blog-single',
          name: 'blog-single',
          component: BlogSingle
        },
        {
          path: '',
          name: 'blog',
          component: Blog
        }
      ]
    },
    {
      path: '/developers',
      component: Developers,
      children: [
        {
          path: 'documentation',
          name: 'documentation',
          component: Documentation
        },
        {
          path: 'api-documentation',
          name: 'api-documentation',
          component: ApiReference
        },
        {
          path: 'sdk',
          name: 'sdk',
          component: Sdk
        },
        {
          path: 'api-status',
          name: 'api-status',
          component: ApiStatus
        },
        {
          path: 'faq',
          name: 'dev-faq',
          component: DevFAQ
        }
      ]
    },
    {
      path: '/personal',
      children: [
        {
          path: 'how-to',
          name: 'per-how-to',
          component: PerHowTo
        },
        {
          path: 'online-payment',
          name: 'per-online-payment',
          component: PerOnPay
        },
        {
          path: 'send-payment',
          name: 'per-send-payment',
          component: PerSenPay
        },
        {
          path: 'request-payment',
          name: 'per-request-payment',
          component: PerReqPay
        },
        {
          path: 'faq',
          name: 'per-faq',
          component: PerFAQ
        }
      ]
    },
    {
      path: '/business',
      component: Business,
      children: [
        {
          path: 'solutions',
          name: 'bus-solutions',
          component: BusSol
        },
        {
          path: 'receive-payments',
          name: 'bus-receive-payments',
          component: BusRecPay
        },
        {
          path: 'send-invoice',
          name: 'bus-send-invoice',
          component: BusSendIn
        },
        {
          path: 'pricing',
          name: 'bus-pricing',
          component: BusPricing
        },
        {
          path: 'faq',
          name: 'bus-faq',
          component: BusFAQ
        }
      ]
    },
    {path: '*', component: FOF}
  ]
})

router.afterEach((to, from) => {
  document.getElementById('navbar').classList.remove('in')
})

export default router



// WEBPACK FOOTER //
// ./src/router.js